import { useState, ChangeEvent, MouseEvent } from 'react';

export function useInput(
  initialInput = ''
): [
  string,
  (
    e: ChangeEvent<HTMLInputElement> | MouseEvent<HTMLButtonElement> | string,
    reset?: boolean
  ) => void
] {
  const [input, setInput] = useState(initialInput);

  /**
   * Handles input changes, button clicks, or direct value setting.
   *
   * @param e Input event, button click event, or direct string value.
   * @param reset If true, resets the input value to an empty string.
   */
  const changeInput = (
    e: ChangeEvent<HTMLInputElement> | MouseEvent<HTMLButtonElement> | string,
    reset?: boolean
  ) => {
    if (reset) {
      setInput('');
      return;
    }

    if (typeof e === 'string') {
      setInput(e);
    } else if ('target' in e && e.target instanceof HTMLInputElement) {
      setInput(e.target.value);
    }
  };

  return [input, changeInput];
}
